import React from "react";

// Source
import StoreRole from "../../store/Role";
import StoreRoute from "../../store/Route";
import StoreLocalization from "../../store/Localization";
import StorePreference from "../../store/Preference";
import * as HelperSrc from "../../HelperSrc";
import * as ModelRole from "../../model/Role";
import * as ModelRoute from "../../model/Route";
import * as ModelCustomRoute from "../../model/custom/Route";
import * as ModelLocalization from "../../model/Localization";
import * as ModelCustomLocalization from "../../model/custom/Localization";
import * as ModelPreference from "../../model/Preference";
import * as ApiInvoice from "../../api/custom/Invoice";
import * as ModelInvoice from "../../model/custom/Invoice";
import ControllerAlert from "../Alert";

export default class ControllerInvoiceProfile {
    // Variable
    private storeRole: ModelRole.Istore;
    private storageRoleData = React.useRef<ModelRole.Idata | undefined>(undefined);
    private storeRoute: ModelRoute.Istore<ModelCustomRoute.Idata>;
    private storageRouteData = React.useRef<ModelCustomRoute.Idata | undefined>(undefined);
    private storeLocalization: ModelLocalization.Istore<ModelCustomLocalization.Idata>;
    private storageLocalizationData = React.useRef<ModelCustomLocalization.Idata | undefined>(undefined);
    private storePreference: ModelPreference.Istore<ModelPreference.Idata>;
    private storagePreferenceData = React.useRef<ModelPreference.Idata | undefined>(undefined);

    private controllerAlert: ControllerAlert;

    private elementViewMain = React.useRef<HTMLElement | null>(null);
    private elementBottom = React.useRef<HTMLElement | null>(null);
    private elementReviewerId = React.useRef<HTMLSelectElement | null>(null);
    private elementPaymentDate = React.useRef<HTMLInputElement | null>(null);

    private isRendered = React.useRef<boolean>(false);
    private validationForm = React.useRef<ModelInvoice.Idata | undefined>(undefined);
    private dataMain = React.useRef<ModelInvoice.Idata | undefined>(undefined);
    private language = React.useRef<string>("");

    getApiLoadingList: Record<string, boolean>;
    setApiLoadingList: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;

    getSelectOption: ModelInvoice.IselectOption | undefined;
    setSelectOption: React.Dispatch<React.SetStateAction<ModelInvoice.IselectOption | undefined>>;

    getInvoiceOption: ModelInvoice.IinvoiceOption | undefined;
    setInvoiceOption: React.Dispatch<React.SetStateAction<ModelInvoice.IinvoiceOption | undefined>>;

    getDataMain: ModelInvoice.Idata | undefined;
    setDataMain: React.Dispatch<React.SetStateAction<ModelInvoice.Idata | undefined>>;

    getValidationForm: ModelInvoice.Idata | undefined;
    setValidationForm: React.Dispatch<React.SetStateAction<ModelInvoice.Idata | undefined>>;

    getUrlFile: string | undefined;
    setUrlFile: React.Dispatch<React.SetStateAction<string | undefined>>;

    getIsDisabledCheckReviewSelect: boolean;
    setIsDisabledCheckReviewSelect: React.Dispatch<React.SetStateAction<boolean>>;

    getIsDisabledCheckReviewAccept: boolean;
    setIsDisabledCheckReviewAccept: React.Dispatch<React.SetStateAction<boolean>>;

    getIsDisabledCheckReviewDecline: boolean;
    setIsDisabledCheckReviewDecline: React.Dispatch<React.SetStateAction<boolean>>;

    getIsDisabledFieldCheckbox: boolean;
    setIsDisabledFieldCheckbox: React.Dispatch<React.SetStateAction<boolean>>;

    getIsDisabledUpdateButton: boolean;
    setIsDisabledUpdateButton: React.Dispatch<React.SetStateAction<boolean>>;

    getTotalPaymentAmount: string;
    setTotalPaymentAmount: React.Dispatch<React.SetStateAction<string>>;

    getPayerDetail: Record<string, Record<string, unknown>>;
    setPayerDetail: React.Dispatch<React.SetStateAction<Record<string, Record<string, unknown>>>>;

    getPayeeDetail: Record<string, Record<string, unknown>>;
    setPayeeDetail: React.Dispatch<React.SetStateAction<Record<string, Record<string, unknown>>>>;

    getPreparerList: string[] | undefined;
    setPreparerList: React.Dispatch<React.SetStateAction<string[] | undefined>>;

    getIsApproved: boolean;
    setIsApproved: React.Dispatch<React.SetStateAction<boolean>>;

    getElementPaymentDate: HTMLInputElement | null;
    setElementPaymentDate: React.Dispatch<React.SetStateAction<HTMLInputElement | null>>;

    getLanguage: string;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;

    getElementReviewerIdValue: string;
    setElementReviewerIdValue: React.Dispatch<React.SetStateAction<string>>;

    getElementClientIdValue: string;
    setElementClientIdValue: React.Dispatch<React.SetStateAction<string>>;

    getElementPayerIdValue: string;
    setElementPayerIdValue: React.Dispatch<React.SetStateAction<string>>;

    getElementPaymentTypeValue: string;
    setElementPaymentTypeValue: React.Dispatch<React.SetStateAction<string>>;

    getElementBusinessSelectionValue: string;
    setElementBusinessSelectionValue: React.Dispatch<React.SetStateAction<string>>;

    getElementPayeeIdValue: string;
    setElementPayeeIdValue: React.Dispatch<React.SetStateAction<string>>;

    // Method
    constructor(isRendered: boolean) {
        this.storeRole = new StoreRole();
        this.storageRoleData.current = this.storeRole.storageGet();
        this.storeRoute = new StoreRoute();
        this.storageRouteData.current = this.storeRoute.storageGet();
        this.storeLocalization = new StoreLocalization();
        this.storageLocalizationData.current = this.storeLocalization.storageGet();
        this.storePreference = new StorePreference();
        this.storagePreferenceData.current = this.storePreference.storageGet();

        this.controllerAlert = new ControllerAlert(isRendered);

        this.isRendered.current = isRendered;

        const [getApiLoadingList, setApiLoadingList] = React.useState<Record<string, boolean>>({});
        this.getApiLoadingList = getApiLoadingList;
        this.setApiLoadingList = setApiLoadingList;

        const [getSelectOption, setSelectOption] = React.useState<ModelInvoice.IselectOption | undefined>(undefined);
        this.getSelectOption = getSelectOption;
        this.setSelectOption = setSelectOption;

        const [getInvoiceOption, setInvoiceOption] = React.useState<ModelInvoice.IinvoiceOption | undefined>(undefined);
        this.getInvoiceOption = getInvoiceOption;
        this.setInvoiceOption = setInvoiceOption;

        const [getDataMain, setDataMain] = React.useState<ModelInvoice.Idata | undefined>(this.dataMain.current);
        this.getDataMain = getDataMain;
        this.setDataMain = setDataMain;

        const [getValidationForm, setValidationForm] = React.useState<ModelInvoice.Idata | undefined>(this.validationForm.current);
        this.getValidationForm = getValidationForm;
        this.setValidationForm = setValidationForm;

        const [getUrlFile, setUrlFile] = React.useState<string | undefined>(undefined);
        this.getUrlFile = getUrlFile;
        this.setUrlFile = setUrlFile;

        const [getIsDisabledCheckReviewSelect, setIsDisabledCheckReviewSelect] = React.useState<boolean>(false);
        this.getIsDisabledCheckReviewSelect = getIsDisabledCheckReviewSelect;
        this.setIsDisabledCheckReviewSelect = setIsDisabledCheckReviewSelect;

        const [getIsDisabledCheckReviewAccept, setIsDisabledCheckReviewAccept] = React.useState<boolean>(false);
        this.getIsDisabledCheckReviewAccept = getIsDisabledCheckReviewAccept;
        this.setIsDisabledCheckReviewAccept = setIsDisabledCheckReviewAccept;

        const [getIsDisabledCheckReviewDecline, setIsDisabledCheckReviewDecline] = React.useState<boolean>(false);
        this.getIsDisabledCheckReviewDecline = getIsDisabledCheckReviewDecline;
        this.setIsDisabledCheckReviewDecline = setIsDisabledCheckReviewDecline;

        const [getIsDisabledFieldCheckbox, setIsDisabledFieldCheckbox] = React.useState<boolean>(false);
        this.getIsDisabledFieldCheckbox = getIsDisabledFieldCheckbox;
        this.setIsDisabledFieldCheckbox = setIsDisabledFieldCheckbox;

        const [getIsDisabledUpdateButton, setIsDisabledUpdateButton] = React.useState<boolean>(false);
        this.getIsDisabledUpdateButton = getIsDisabledUpdateButton;
        this.setIsDisabledUpdateButton = setIsDisabledUpdateButton;

        const [getTotalPaymentAmount, setTotalPaymentAmount] = React.useState<string>("");
        this.getTotalPaymentAmount = getTotalPaymentAmount;
        this.setTotalPaymentAmount = setTotalPaymentAmount;

        const [getPayerDetail, setPayerDetail] = React.useState<Record<string, Record<string, unknown>>>({});
        this.getPayerDetail = getPayerDetail;
        this.setPayerDetail = setPayerDetail;

        const [getPayeeDetail, setPayeeDetail] = React.useState<Record<string, Record<string, unknown>>>({});
        this.getPayeeDetail = getPayeeDetail;
        this.setPayeeDetail = setPayeeDetail;

        const [getPreparerList, setPreparerList] = React.useState<string[] | undefined>(undefined);
        this.getPreparerList = getPreparerList;
        this.setPreparerList = setPreparerList;

        const [getIsApproved, setIsApproved] = React.useState<boolean>(false);
        this.getIsApproved = getIsApproved;
        this.setIsApproved = setIsApproved;

        const [getElementPaymentDate, setElementPaymentDate] = React.useState<HTMLInputElement | null>(null);
        this.getElementPaymentDate = getElementPaymentDate;
        this.setElementPaymentDate = setElementPaymentDate;

        const [getLanguage, setLanguage] = React.useState<string>(this.language.current);
        this.getLanguage = getLanguage;
        this.setLanguage = setLanguage;

        const [getElementReviewerIdValue, setElementReviewerIdValue] = React.useState<string>("");
        this.getElementReviewerIdValue = getElementReviewerIdValue;
        this.setElementReviewerIdValue = setElementReviewerIdValue;

        const [getElementClientIdValue, setElementClientIdValue] = React.useState<string>("");
        this.getElementClientIdValue = getElementClientIdValue;
        this.setElementClientIdValue = setElementClientIdValue;

        const [getElementPayerIdValue, setElementPayerIdValue] = React.useState<string>("");
        this.getElementPayerIdValue = getElementPayerIdValue;
        this.setElementPayerIdValue = setElementPayerIdValue;

        const [getElementPaymentTypeValue, setElementPaymentTypeValue] = React.useState<string>("");
        this.getElementPaymentTypeValue = getElementPaymentTypeValue;
        this.setElementPaymentTypeValue = setElementPaymentTypeValue;

        const [getElementBusinessSelectionValue, setElementBusinessSelectionValue] = React.useState<string>("");
        this.getElementBusinessSelectionValue = getElementBusinessSelectionValue;
        this.setElementBusinessSelectionValue = setElementBusinessSelectionValue;

        const [getElementPayeeIdValue, setElementPayeeIdValue] = React.useState<string>("");
        this.getElementPayeeIdValue = getElementPayeeIdValue;
        this.setElementPayeeIdValue = setElementPayeeIdValue;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_invoice_profile", () => {
                this.initializeHtmlElement();
            });

            this.apiSelectOption("invoice");

            let validationFormType = "create";

            const historyState = window.history.state as Record<string, unknown> | undefined;

            if (historyState) {
                const parameterList = historyState.parameterList as ModelInvoice.Idata;

                if (parameterList) {
                    validationFormType = "create";

                    this.dataMain.current = { ...parameterList };
                } else {
                    validationFormType = "update";

                    this.dataMain.current = {} as ModelInvoice.Idata;
                }
            } else {
                this.dataMain.current = {} as ModelInvoice.Idata;
            }

            this.setDataMain(this.dataMain.current);

            this.apiValidationForm(validationFormType);

            for (const key of Object.keys(this.dataMain.current.item)) {
                const payer = this.dataMain.current.item[key].payer_id;
                this.apiPayerDetail(String(payer), key);

                const payee = this.dataMain.current.item[key].payee_id;
                this.apiPayeeDetail(String(payee), key);
            }

            const invoiceId = Number(this.dataMain.current.id || 0);

            if (invoiceId > 0) {
                this.apiInvoiceOption(invoiceId, 0, () => {
                    const formData = new FormData();
                    formData.append("id", String(invoiceId));

                    ApiInvoice.previewFile(formData, (response) => {
                        if (response instanceof Error || response.message.error) {
                            if (response instanceof Error) {
                                HelperSrc.writeLog("error", response.message);
                            } else {
                                this.controllerAlert.show("error", response.message.error, false);
                            }

                            return;
                        }

                        this.showFile(response.data.result as unknown as string);
                    });

                    ApiInvoice.invoicePreparer(invoiceId, (response) => {
                        if (response instanceof Error || response.message.error) {
                            if (response instanceof Error) {
                                HelperSrc.writeLog("error", response.message);
                            } else {
                                this.controllerAlert.show("error", response.message.error, false);
                            }

                            return;
                        }

                        this.setPreparerList(response.data.result as unknown as string[]);
                    });
                });
            }

            HelperSrc.storageEventListener("localization", () => {
                this.apiValidationForm(validationFormType);
            });

            if (this.dataMain.current.status_id === 1 || this.dataMain.current.status_id === 5 || this.dataMain.current.status_id === 7) {
                this.setIsDisabledCheckReviewSelect(true);
            }

            if (this.dataMain.current.status_id === 1 || this.dataMain.current.status_id === 7) {
                this.setIsDisabledCheckReviewAccept(true);
            }

            if (
                this.dataMain.current.status_id === 1 ||
                this.dataMain.current.status_id === 2 ||
                this.dataMain.current.status_id === 3 ||
                this.dataMain.current.status_id === 6 ||
                this.dataMain.current.status_id === 7
            ) {
                this.setIsDisabledCheckReviewDecline(true);
                this.setIsDisabledFieldCheckbox(true);
            }

            if (this.dataMain.current.status_id === 4 || this.dataMain.current.status_id === 5 || this.dataMain.current.status_id === 7) {
                this.setIsDisabledUpdateButton(true);
            }

            this.setTotalPaymentAmount(this.dataMain.current.total_payment_amount);

            this.setIsApproved(this.dataMain.current.status_id >= 7);
        }, []);

        React.useEffect(() => {
            this.storageRoleData.current = this.storeRole.storageGet();
            this.storageRouteData.current = this.storeRoute.storageGet();
            this.storageLocalizationData.current = this.storeLocalization.storageGet();
        }, [this.storageRoleData.current, this.storageRouteData.current, this.storageLocalizationData.current]);

        React.useEffect(() => {
            this.storagePreferenceData.current = this.storePreference.storageGet();

            if (this.storagePreferenceData.current) {
                const initialLanguage = this.language.current;

                if (this.dataMain.current && this.language.current !== this.storagePreferenceData.current.language) {
                    this.language.current = this.storagePreferenceData.current.language;
                    this.setLanguage(this.language.current);

                    if (initialLanguage !== "") {
                        let clientId = this.readHtmlElementValue("client_id");
                        if (clientId === "") {
                            clientId = "0";
                        }

                        this.apiSelectOption("invoice");
                        this.apiInvoiceOption(this.dataMain.current.id, clientId as unknown as number);
                    }
                }
            }

            HelperSrc.updateInputDate();
        }, [this.storagePreferenceData.current]);
    };

    clickChange = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        const element = event.target as HTMLElement;

        const checkForm = HelperSrc.checkForm(element, this.validationForm.current);

        if (!checkForm) {
            return;
        }

        this.setApiLoadingList((prev) => ({
            ...prev,
            profileChange: true
        }));

        if (this.dataMain.current && this.dataMain.current.id) {
            const id = this.dataMain.current.id;
            const detail = this.readHtmlElementValue("detail");
            const client_id = this.readHtmlElementValue("client_id") as unknown as number;
            const type = this.readHtmlElementValue("type");
            const number = this.readHtmlElementValue("number");
            const total_payment_amount = this.readHtmlElementValue("total_payment_amount");
            const payment_date = this.readHtmlElementValue("payment_date");

            let itemList: Record<string, unknown> | string = "";

            if (this.dataMain.current.item) {
                itemList = {};

                for (const key of Object.keys(this.dataMain.current.item)) {
                    itemList[key] = {
                        payer_id: this.readHtmlElementValue(`payer_${key}`),
                        payment_type: this.readHtmlElementValue(`payment_type_${key}`),
                        business_selection: this.readHtmlElementValue(`business_selection_${key}`),
                        requester: this.readHtmlElementValue(`requester_${key}`),
                        payment_amount: this.readHtmlElementValue(`payment_amount_${key}`),
                        payee_id: this.readHtmlElementValue(`payee_${key}`)
                    };
                }

                if (Object.keys(itemList).length === 0) {
                    itemList = "";
                }
            }

            const file_number = this.readHtmlElementValue("file_number");
            const memo = this.readHtmlElementValue("memo");

            ApiInvoice.updateData(
                id,
                detail,
                client_id,
                type,
                number,
                total_payment_amount,
                payment_date,
                itemList,
                file_number,
                memo,
                (response) => {
                    this.setApiLoadingList((prev) => ({
                        ...prev,
                        profileChange: false
                    }));

                    if (response instanceof Error || response.message.error) {
                        if (response instanceof Error) {
                            HelperSrc.writeLog("error", response.message);
                        } else {
                            this.controllerAlert.show("error", response.message.error, false);
                        }

                        return;
                    }

                    this.controllerAlert.show("success", response.message.success, true);
                }
            );
        } else {
            let itemList: Record<string, unknown> | string = "";

            if (this.dataMain.current && this.dataMain.current.item) {
                itemList = {};

                for (const key of Object.keys(this.dataMain.current.item)) {
                    itemList[key] = {
                        payer_id: this.readHtmlElementValue(`payer_${key}`),
                        payment_type: this.readHtmlElementValue(`payment_type_${key}`),
                        business_selection: this.readHtmlElementValue(`business_selection_${key}`),
                        requester: this.readHtmlElementValue(`requester_${key}`),
                        payment_amount: this.readHtmlElementValue(`payment_amount_${key}`),
                        payee_id: this.readHtmlElementValue(`payee_${key}`)
                    };
                }

                if (Object.keys(itemList).length === 0) {
                    itemList = "";
                }
            }

            ApiInvoice.createData(
                this.readHtmlElementValue("detail"),
                this.readHtmlElementValue("client_id") as unknown as number,
                this.readHtmlElementValue("type"),
                this.readHtmlElementValue("number"),
                this.readHtmlElementValue("total_payment_amount"),
                this.readHtmlElementValue("payment_date"),
                itemList,
                this.readHtmlElementValue("file_number"),
                this.readHtmlElementValue("memo"),
                (response) => {
                    this.setApiLoadingList((prev) => ({
                        ...prev,
                        profileChange: false
                    }));

                    if (response instanceof Error || response.message.error) {
                        if (response instanceof Error) {
                            HelperSrc.writeLog("error", response.message);
                        } else {
                            this.controllerAlert.show("error", response.message.error, false);
                        }

                        return;
                    }

                    this.controllerAlert.show("success", response.message.success, true);
                }
            );
        }
    };

    clickCheckReview = (mode: string): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            checkReview: true
        }));

        const id = this.getDataMain ? this.getDataMain.id : 0;
        const reviewerId =
            this.elementReviewerId.current && this.elementReviewerId.current.value !== ""
                ? (this.elementReviewerId.current.value as unknown as number)
                : mode === "reset" || (this.dataMain.current && this.dataMain.current.status_id === 5)
                  ? 0
                  : "";
        const reviewMetadata = {
            detail: this.readHtmlElementCheckbox("detail_metadata"),
            client_id: this.readHtmlElementCheckbox("client_id_metadata"),
            type: this.readHtmlElementCheckbox("type_metadata"),
            number: this.readHtmlElementCheckbox("number_metadata"),
            total_payment_amount: this.readHtmlElementCheckbox("total_payment_amount_metadata"),
            payment_date: this.readHtmlElementCheckbox("payment_date_metadata"),
            item: this.readHtmlElementCheckbox("item_metadata"),
            file_number: this.readHtmlElementCheckbox("file_number_metadata"),
            memo: this.readHtmlElementCheckbox("memo_metadata")
        };

        ApiInvoice.checkReview(id, reviewerId, mode, reviewMetadata, (response) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                checkReview: false
            }));

            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.controllerAlert.show("success", response.message.success, true);

            const statusId = response.data.result as unknown as number;

            if (statusId === 4 || statusId === 5 || statusId === 6 || statusId === 7) {
                this.setIsDisabledCheckReviewSelect(true);
                this.setIsDisabledCheckReviewAccept(true);
                this.setIsDisabledCheckReviewDecline(true);
            } else {
                this.setIsDisabledCheckReviewSelect(false);
                this.setIsDisabledCheckReviewAccept(false);
                this.setIsDisabledCheckReviewDecline(false);
            }

            if (statusId === 4 || statusId === 5 || statusId === 7) {
                this.setIsDisabledUpdateButton(true);
            }

            this.setIsApproved(statusId >= 7);
        });
    };

    clickAddItem = (): void => {
        if (this.dataMain.current) {
            if (!this.dataMain.current.item) {
                this.dataMain.current.item = {};
            }

            const keys = Object.keys(this.dataMain.current.item);
            let maxId = 0;

            for (let a = 0; a < keys.length; a++) {
                const num = parseInt(keys[a]);

                if (!isNaN(num) && num > maxId) {
                    maxId = num;
                }
            }

            const itemId = maxId + 1;

            this.dataMain.current.item = {
                ...this.dataMain.current.item,
                [itemId]: {
                    payer: "",
                    payment_type: "",
                    business_selection: "",
                    requester: "",
                    payment_amount: "",
                    payee: ""
                }
            };

            const dataMain = {
                ...this.dataMain.current,
                item: this.dataMain.current.item
            } as ModelInvoice.Idata;

            this.setDataMain(dataMain);

            this.setPayerDetail((prev) => ({
                ...prev,
                [itemId]: {}
            }));

            this.setPayeeDetail((prev) => ({
                ...prev,
                [itemId]: {}
            }));
        }
    };

    clickRemoveItem = (key): void => {
        if (this.dataMain.current) {
            delete this.dataMain.current.item[key];

            const dataMain = {
                ...this.dataMain.current,
                item: this.dataMain.current.item
            } as ModelInvoice.Idata;

            this.setDataMain(dataMain);

            this.setPayerDetail((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });

            this.setPayeeDetail((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
        }
    };

    onChangeItem = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string): void => {
        if (this.dataMain.current) {
            const name = event.target.name;
            const payerValue = name === `payer_${key}` ? event.target.value : this.readHtmlElementValue(`payer_${key}`);
            const paymentTypeValue = name === `payment_type_${key}` ? event.target.value : this.readHtmlElementValue(`payment_type_${key}`);
            const businessSelectionValue =
                name === `business_selection_${key}` ? event.target.value : this.readHtmlElementValue(`business_selection_${key}`);
            const requesterValue = name === `requester_${key}` ? event.target.value : this.readHtmlElementValue(`requester_${key}`);
            const paymentAmountValue = name === `payment_amount_${key}` ? event.target.value : this.readHtmlElementValue(`payment_amount_${key}`);
            const payeeValue = name === `payee_${key}` ? event.target.value : this.readHtmlElementValue(`payee_${key}`);

            this.dataMain.current.item = {
                ...this.dataMain.current.item,
                [key]: {
                    payer_id: payerValue as unknown as number,
                    payment_type: paymentTypeValue,
                    business_selection: businessSelectionValue,
                    requester: requesterValue,
                    payment_amount: paymentAmountValue,
                    payee_id: payeeValue as unknown as number
                }
            };

            const dataMain = {
                ...this.dataMain.current,
                item: this.dataMain.current.item
            } as ModelInvoice.Idata;

            this.setDataMain(dataMain);
        }
    };

    onChangePayer = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string): void => {
        this.apiPayerDetail(event.target.value, key);
    };

    onChangePayee = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string): void => {
        this.apiPayeeDetail(event.target.value, key);
    };

    onChangeClient = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (this.dataMain.current) {
            if (event.target.value === "") {
                this.setInvoiceOption(
                    (prev) =>
                        ({
                            ...prev,
                            payer_id: [],
                            payee_id: []
                        }) as unknown as ModelInvoice.IinvoiceOption | undefined
                );
            } else {
                this.apiInvoiceOption(this.dataMain.current.id, event.target.value as unknown as number);
            }
        }
    };

    private showFile = (file: string): void => {
        const decodedData = window.atob(file);
        const uint8Array = new Uint8Array(decodedData.length);

        for (let a = 0; a < decodedData.length; a++) {
            uint8Array[a] = decodedData.charCodeAt(a);
        }

        const blob = new Blob([uint8Array], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        this.setUrlFile(url);
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementBottom.current = document.querySelector<HTMLElement>(".bottom");
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_invoice_profile");
            this.elementReviewerId.current = document.querySelector<HTMLSelectElement>("[name='reviewer_id']");
            this.elementPaymentDate.current = document.querySelector<HTMLInputElement>("[name='payment_date']");

            this.setElementPaymentDate(this.elementPaymentDate.current);
        }
    };

    private apiSelectOption = (mode: string): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            selectOption: true
        }));

        ApiInvoice.selectOption(mode, (response) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                selectOption: false
            }));

            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.setSelectOption(response.data.result as unknown as ModelInvoice.IselectOption);
        });
    };

    private apiInvoiceOption = (id: number, clientId: number, onSuccess?: () => void): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            invoiceOption: true
        }));

        ApiInvoice.invoiceOption(id, clientId, (response) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                invoiceOption: false
            }));

            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.setInvoiceOption(response.data.result as unknown as ModelInvoice.IinvoiceOption);

            if (onSuccess) {
                onSuccess();
            }
        });
    };

    private apiPayerDetail = (id: string, key: string): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            payerDetail: true
        }));

        if (id === "") {
            this.setPayerDetail((prev) => ({
                ...prev,
                [key]: {}
            }));
        } else {
            ApiInvoice.payerDetail(id, (response) => {
                this.setApiLoadingList((prev) => ({
                    ...prev,
                    payerDetail: false
                }));

                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        this.controllerAlert.show("error", response.message.error, false);
                    }

                    return;
                }

                this.setPayerDetail((prev) => ({
                    ...prev,
                    [key]: response.data.result
                }));
            });
        }
    };

    private apiPayeeDetail = (id: string, key: string): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            payerDetail: true
        }));

        if (id === "") {
            this.setPayeeDetail((prev) => ({
                ...prev,
                [key]: {}
            }));
        } else {
            ApiInvoice.payeeDetail(id, (response) => {
                this.setApiLoadingList((prev) => ({
                    ...prev,
                    payerDetail: false
                }));

                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        this.controllerAlert.show("error", response.message.error, false);
                    }

                    return;
                }

                this.setPayeeDetail((prev) => ({
                    ...prev,
                    [key]: response.data.result
                }));
            });
        }
    };

    private readHtmlElementValue = (tag: string): string => {
        const element = document.querySelector<HTMLInputElement>(`[name='${tag}']`);

        return element ? element.value : "";
    };

    private readHtmlElementCheckbox = (tag: string): boolean => {
        const element = document.querySelector<HTMLInputElement>(`[name='${tag}']`);

        return element ? element.checked : false;
    };

    private apiValidationForm = (type: string): void => {
        ApiInvoice.validationForm(type, (response) => {
            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.validationForm.current = response.data.result as unknown as ModelInvoice.Idata;
            this.setValidationForm(this.validationForm.current);

            if (this.elementBottom.current) {
                HelperSrc.validationFormHelper(this.elementBottom.current, this.validationForm.current);
            }
        });
    };
}
